<template>
  <div class="print-break-after measures-sheet-container">
    <div v-show="tabToShow === 'default'" class="wg-row">
      <div class="wg-col wg-xs-12">
        <div
          style="font-size:17px;"
          class="com-anm22-app-text-m suit-model"
        >{{$anm22.strLang(lang, "Status", "Stato")}}: {{statusLabel}}</div>
      </div>
      <div class="vertical-height-div" style="height:20px;">&nbsp;</div>
      <div class="wg-col wg-xs-5">
        <div
          style="font-size:17px;"
          class="com-anm22-app-text-m suit-model"
        >{{$anm22.strLang(lang, "Items", "Articoli")}}</div>
      </div>
      <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
      <div>
        <div v-if="materialsData.materials.length == 0">{{$anm22.strLang(lang, "Empty list", "Nessun articolo")}}</div>
        <div
          v-for="(material,index) in materialsData.materials"
          :key="index"
          class="material-item"
        >
          x<input
            type="number"
            v-model="materialsData.materials[index].quantity"
            step="0.1"
            class="qnt"
            @change="materialsDataToSave = true" />
          {{getProductNameById(material.product)}} 
          <img
            class="com-anm22-app-img-fixed-height-l"
            style="padding:5px;display:inline-block;cursor:pointer"
            :src="$anm22.icons.getWorldIcon('deleteBin')"
            @click="removeItem(material.product)"
          />
        </div>
        <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
        <div @click="tabToShow = 'addProduct'" class="add-product-btn"><span class="add-ic">+</span> {{$anm22.strLang(lang, "Add item", "Aggiungi articolo")}}</div>
      </div>
      <template v-if="(mode === 'edit') && (materialsData.status === 0)">
        <div class="vertical-height-div" style="height:40px;">&nbsp;</div>
        <div class="wg-col wg-xs-12">
          <div
            class="import-material-btn"
            @click="tabToShow = 'importMaterialList'"
          >
            <img
              class="com-anm22-app-img-fixed-height-l import-material-btn-ic"
              :src="$anm22.icons.getWorldIcon('upload')"
            />
            {{$anm22.strLang(lang, "Import material list", "Importa distinta base")}}
          </div>
        </div>
      </template>
      <div class="vertical-height-div" style="height:40px;">&nbsp;</div>
      <div v-if="lastEditDate" class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div
            class="com-anm22-app-text-m"
          >{{ $anm22.strLang(lang, 'Last edit', 'Ultima modifica') }}</div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">{{ lastEditDate + ' ' + lastEditUser }}</div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;">&nbsp;</div>
      <template v-if="(mode === 'edit') && (materialsDataToSave === true) && (materialsData.status === 0)">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input type="button" :value="$anm22.strLang(lang, 'Save', 'Salva')" @click="saveForm" />
        </div>
      </template>
      <template v-if="(mode === 'edit') && (materialsDataToSave === false) && (materialsData.status === 0)">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input type="button" :value="$anm22.strLang(lang, 'Send to warehouse', 'Invia al magazzino')" @click="sendToWarehouse()" />
        </div>
      </template>
      <template v-if="(mode === 'edit') && (materialsDataToSave === true) && (materialsData.status === 1)">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <input type="button" :value="$anm22.strLang(lang, 'Save and send', 'Salva e invia')" @click="saveForm" />
        </div>
      </template>
    </div>
    <div v-show="tabToShow === 'addProduct'">
      <div class="wg-col wg-xs-5">
        <div
          style="font-size:17px;"
          class="com-anm22-app-text-m suit-model"
        >{{$anm22.strLang(lang, "Add item", "Aggiungi articolo")}}</div>
      </div>
      <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
      <div class="products-list">
        <div
          class="wg-row product-row header"
        >
          <div class="code">{{ $anm22.strLang(lang, 'Code', 'Codice') }}</div>
          <div class="name">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
          <div class="category">{{ $anm22.strLang(lang, 'Category', 'Categoria') }}</div>
        </div>
        <div
          v-for="(product,index) in products"
          :key="index"
          @click="addItem(product.idWarehouseProduct)"
          class="product-row"
        >
          <div class="code">{{ product.code }}</div>
          <div class="name">{{ product.name }}</div>
          <div class="category">{{ getProductCategoryNameById(product.category) }}</div>
          <div class="color"><div class="color-preview" :title="product.colorString" :style="{'background-color':product.colorString}" ></div></div>
        </div>
      </div>
    </div>
    <div v-show="tabToShow === 'importMaterialList'" class="wg-row">
      <div class="wg-col wg-xs-5">
        <div
          style="font-size:17px;"
          class="com-anm22-app-text-m suit-model"
        >{{$anm22.strLang(lang, "Import material list", "Importa distinta base")}}</div>
      </div>
      <div class="vertical-height-div" style="height:10px;">&nbsp;</div>
      <div class="material-lists-list">
        <div v-if="materialsLists.length == 0">{{$anm22.strLang(lang, "Empty list", "Nessuna distinta base disponibile")}}</div>
        <div
          v-for="(materialsList, index) in materialsLists"
          :key="index"
          @click="importMaterialsList(materialsList)"
          class="material-list-row"
        >
          <div class="name">{{materialsList.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    sizes: Array,
    mode: {
      type: String,
      default: "edit"
    }
  },
  data() {
    return {
      materialsData: {
        status: 0,
        materials: []
      },
      tabToShow: "default",
      products: [],
      productCategories: [],
      materialsLists: [],
      materialsDataToSave: false,
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.materialsData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.materialsData.lastUpdate
        ? this.$moment
            .unix(this.materialsData.lastUpdate)
            .format("DD/MM/YYYY HH:mm")
        : "";
    },
    statusLabel() {
      if (typeof this.materialsData.status != 'undefined') {
        switch (this.materialsData.status) {
          case 0:
            return this.$anm22.strLang(this.lang, "Draft", "Bozza");
          case 1:
            return this.$anm22.strLang(this.lang, "Sent to warehouse", "Inviata al magazzino");
          default:
            return this.$anm22.strLang(this.lang, "Draft", "Bozza");
        }
      } else {
        return this.$anm22.strLang(this.lang, "Not defined", "Non definito");
      }
    },
  },
  methods: {
    saveForm() {
      const docs = { ...this.docs };
      docs.materials = this.materialsData;
      docs.materials.lastUser = this.user.idWorldUser;
      docs.materials.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.materialsDataToSave = false;
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    sendToWarehouse() {
      const docs = { ...this.docs };
      this.materialsData.status = 1;
      docs.materials = this.materialsData;
      docs.materials.lastUser = this.user.idWorldUser;
      docs.materials.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.materialsDataToSave = false;
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    loadWarehouseData() {
      this.$http
        .get("products")
        .then((response) => {
          this.products = response.data.products;
          this.productCategories = response.data.categories;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadMaterialsLists() {
      this.$http
        .get("vircos/materials-lists")
        .then((response) => {
          this.materialsLists = response.data.materialsLists;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getProductById(productId) {
      let product = null;
      this.products.forEach(function(element) {
        if (element.idWarehouseProduct == productId) {
          product = element;
        }
      });
      return product;
    },
    getProductNameById(productId) {
      const product = this.getProductById(productId);
      if (product) {
        return product.name;
      } else {
        return '';
      }
    },
    getProductCategoryById(categoryId) {
      let categroy = null;
      this.productCategories.forEach(function(element) {
        if (element.idWarehouseCategory == categoryId) {
          categroy = element;
        }
      });
      return categroy;
    },
    getProductCategoryNameById(categoryId) {
      const category = this.getProductCategoryById(categoryId);
      if (category) {
        return category.name;
      } else {
        return '';
      }
    },
    addItem(productId) {
      const index = this.materialsData.materials.map(e => e.product).indexOf(productId);
      if (index >= 0) {
        this.materialsData.materials[index].quantity++;
      } else {
        this.materialsData.materials.push({quantity: 1, product: productId});
      }
      this.materialsDataToSave = true;
      this.tabToShow = 'default';
    },
    removeItem(productId) {
      const index = this.materialsData.materials.map(e => e.product).indexOf(productId);
      if (index >= 0) {
        this.materialsData.materials.splice(index, 1);
        this.materialsDataToSave = true;
      }
    },
    importMaterialsList(materialsList) {
      this.materialsData.materials = materialsList.materials.materials;
      this.materialsDataToSave = true;
      this.tabToShow = 'default';
    },
  },
  created() {
    this.loadWarehouseData();
    this.loadMaterialsLists();
    if (typeof this.docs.materials != 'undefined' && typeof this.docs.materials.materials != 'undefined') {
      this.materialsData = { ...this.docs.materials };
    }
  }
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-text {
  padding-left: 10px;
}
.input-elem {
  width: 100%;
  max-width: 200px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.pic-viewer {
  height: calc(90vh - 90px);
  width: 100%;
  justify-content: center;
}
.products-list {
  overflow-x: auto;

  .product-row {
    border-radius: 8px;
    min-height: 49px;
    padding: 5px;
    flex-wrap: nowrap;
    cursor: pointer;
    display: flex;

    &:hover {
      background-color: #eeeeee;
    }
    div {
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      padding:11px;

      &.code {
        width:25%;
        min-width: 60px;
      }
      &.name {
        width:45%;
        min-width: 120px;
      }
      &.category {
        width:calc(30% - 42px);
        min-width: 120px;
      }
      &.color {
        width:42px;

        .color-preview {
          border:1px solid #ddd;
          border-radius: 10px;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          padding: 0;
        }
      }
    }

    &.header {
      cursor: default;
      div {
        font-weight: 600;
      }
    }
  }
}
.add-product-btn {
  cursor: pointer;
  
  .add-ic {
    color:#66bb6a;
    font-size:24px;
    vertical-align:middle;
    margin-right:5px
  }
}
.import-material-btn {
  font-size:17px;
  cursor: pointer;

  .import-material-btn-ic {
    padding:5px;
    display:inline-block;
  }
}
@media print {
  .input-row.measure {
    margin: 0;
    height: 28px;
    input {
      height: 28px;
      padding: 5px 10px;
    }
  }
  .print-break-after {
    break-after: page;
  }
}
.material-item {
  margin:2px 0;
  
  .qnt {
    display: inline-block;
    vertical-align: middle;
    width:50px;
  }
}

.material-lists-list {
  overflow-x: auto;
  width: 100%;

  .material-list-row {
    border-radius: 8px;
    min-height: 49px;
    padding: 5px;
    flex-wrap: nowrap;
    cursor: pointer;
    display: flex;

    &:hover {
      background-color: #eeeeee;
    }
    div {
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      padding:11px;
      box-sizing: border-box;

      &.name {
        width: 100%;
        min-width: 120px;
      }
    }
  }
}
</style>
